import * as API from "@/api/index.js"

export default {
  name: "user-info-panel",
  components: {

  },

  model:{

  },

  props: {

    source:{
      type: Object,
      default: function () {
        return {}
      }
    },

    user_id:{
      type: String,
      default: "",
    }


  },

  data() {
    var validate_space = (rule, value, callback) => {
      var pattern = /\s+/g;
        if (pattern.test(value)) {
          callback(new Error('不能为空，请输入有效字符'));
        } else {
          callback();
        }
    };

    var validate_pass = (rule, value, callback) => {
        if (this.form.userpwd && (value === '' || value === undefined)) {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.userpwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };

    return {
      data: {},
      loading: false,
      content_style:{
        flexWrap: 'wrap',
        justifyContent: 'flex-start'
      },

      op: "show",   // show   edit
      form: {
        userid: '',
        username: '',
        nick: '',
        userpwd: '',
        userpwd2: '',
        email: '',
        tel:'',
        statu: true,
      },
      form_rules:{

        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur'},
          { validator: validate_space, trigger: 'blur'}
          ],

        nick: [
          { required: true, message: '昵称不能为空', trigger: 'blur'},
          { validator: validate_space, trigger: 'blur'}
          ],

        email: [
          { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: "请输入合法的邮箱", trigger: "blur" },
        ],

        tel:[
          {pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur"},
        ],

        userpwd2: [
            { validator: validate_pass, trigger: 'blur' }
          ],
      },

    }
  },
  mounted() {

    this.get_data()

  },

  computed: {

    info_show(){
      return function (field) {
        let text = this.data[field];
        if (text){
          return text.split(",")
        }
        return ""
      }
    },

  },

  watch: {

    user_id(val){
      this.get_data()
    },


  },

  methods: {

    handle_cancel(){
      this.op = 'show'
    },

     handle_op(){
       if(this.op === 'show'){
         this.op = 'edit'
         for(var key in this.form){
           this.form[key] = this.data[key]
         }
       }else if(this.op === 'edit'){
         this.$refs.form_ref.validate((valid) => {
          if (valid) {
            let param = Object.assign({}, this.form)
            if(!param.userpwd){
              delete param.userpwd
              delete param.userpwd2
            }
            this.user_upd_req(param)
          }
        });
       }
     },

    edit_success(){
      this.$emit('edit_success');
      for(var key in this.form){
        this.data[key] = this.form[key]
      }
      this.op = 'show';
    },


    async user_upd_req(param) {
      this.loading = true
      const response = await API.PUT('/omnis/system/user_management/', param)
      this.loading = false
      if (response && response.data) {
        let data = response.data;
        if (data.success) {
          this.$message.success(data.msg);
          this.edit_success()
        } else {
          this.$message.error(data.msg);
        }
      } else {
        this.$message.error('系统错误');
      }
    },

     async get_data(){
       if (!this.user_id){
         return
       }
        let param = {user_id: this.user_id}
        this.loading = true
        const response = await API.GET('/omnis/system/user_management/', param)
        this.loading = false
        let data = response.data
        if (data.success) {
           this.data = data.data[0]
        }else {
          this.$message.error(data.msg)
        }

     },
  },

}



// WEBPACK FOOTER //
// ./src/omnis-business/user-info-panel/user-info-panel.js